module.exports = __webpack_public_path__ + "static/cercazone_nordest1-98b5c0ba690b089e3bc5c7d27cd231c0.jpg";